import service from '@/store/services/workshop/nota_part-service';

const state = {
  list: {},
  nota_part: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, nota_part) => {
    state.nota_part = nota_part;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((nota_part) => { commit('SET_RESOURCE', nota_part); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((nota_part) => { commit('SET_RESOURCE', nota_part); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((nota_part) => { commit('SET_RESOURCE', nota_part); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((nota_part) => { commit('SET_RESOURCE', nota_part); });
  },

  // nota_part_date({commit, dispatch}, params) {
  //   return service.nota_part_date(params)
  //   .then(({list, meta}) => {
  //     commit('SET_LIST', list);
  //     commit('SET_META', meta);
  //   });
  // },
  
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  nota_part: state => state.nota_part,
  page: state => state.meta.page,
};
 
const nota_part = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default nota_part;
